import { render, staticRenderFns } from "./holder-data-partial.vue?vue&type=template&id=14ae93ce"
import script from "./holder-data-partial.vue?vue&type=script&lang=js"
export * from "./holder-data-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports